<template>
  <div class="row mb-4 mb-4">
    <div class="col-12 col-md-8">
      <button
        v-if="!showCondition"
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('word', 'active')"
      >
        Descargar Word
      </button>

      <!-- <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('excel', 'active')"
      >
        Descargar Excel
      </button> -->

      <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('pdf', 'active')"
      >
        Descargar PDF
      </button>
    </div>
    <div class="col-12 col-md-4">
      <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
        <button
          type="button"
          class="btn btn-primary btn-with-shadow"
          data-toggle="modal"
          @click="openAddEditModal"
        >
          Añadir líneas
        </button>
      </div>
    </div>

    <br /><br />
    <div class="col-12 mt-4">
      <app-table :id="tableId" :options="options" @action="getListAction" />

      <scopes-evaluator-modal
        v-if="isAddEditModalActive"
        modalTitle="Añadir Alcance"
        editModalTitle="Editar Alcance"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
        :activity="activity"
      />

      <!-- <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este registro?"
      /> -->

      <scopes-evaluator-delete-modal
        v-if="deleteConfirmationModalActive"
        modalTitle="Eliminar Alcance"
        :id="rowData.id"
        :table-id="tableId"
        @close-modal="closeAddEditModal"
      />
    </div>

    <!-- <div v-if="show401">
      <div class="col-12 col-md-8 mt-4">
        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('word', 'historical')"
        >
          Descargar Word
        </button>

        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('excel', 'historical')"
        >
          Descargar Excel
        </button>

        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('pdf', 'historical')"
        >
          Descargar PDF
        </button>
      </div>

      <div class="col-12">
        <legend class="col-12 col-form-label text-primary pt-0 my-3">
          <h5>Historico de edición de alcances - Evaluación Documental</h5>
        </legend>

        <app-table :id="tableId" :options="options401" />
      </div>
    </div>

    <div v-if="show505">
      <div class="col-12 col-md-8 mt-4">
        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('word', 'historical')"
        >
          Descargar Word
        </button>

        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('excel', 'historical')"
        >
          Descargar Excel
        </button>

        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('pdf', 'historical')"
        >
          Descargar PDF
        </button>
      </div>

      <div class="col-12">
        <legend class="col-12 col-form-label text-primary pt-0 my-3">
          <h5>
            Historico de edición de alcances - Evaluación In Situ / Remota
          </h5>
        </legend>

        <app-table :id="tableId" :options="options505" />
      </div>
    </div>

    <div v-if="show605">
      <div class="col-12 col-md-8 mt-4">
        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('word', 'historical')"
        >
          Descargar Word
        </button>

        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('excel', 'historical')"
        >
          Descargar Excel
        </button>

        <button
          type="button"
          class="btn btn-success btn-with-shadow"
          data-toggle="modal"
          @click="openTab('pdf', 'historical')"
        >
          Descargar PDF
        </button>
      </div>

      <div class="col-12">
        <legend class="col-12 col-form-label text-primary pt-0 my-3">
          <h5>Historico de edición de alcances - Comisión</h5>
        </legend>

        <app-table :id="tableId" :options="options605" />
      </div>
    </div> -->

    <div class="col-12 col-md-8 mt-4" v-if="showOriginal">
      <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('word', 'original')"
      >
        Descargar Word
      </button>

      <!-- <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('excel', 'original')"
      >
        Descargar Excel
      </button> -->

      <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('pdf', 'original')"
      >
        Descargar PDF
      </button>
    </div>

    <div class="col-12" v-if="showOriginal">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>Alcance registrado en la solicitud.</h5>
      </legend>

      <app-table :id="tableId" :options="optionsOriginal" />
    </div>

    <historical-scope-modal
      v-if="historicalModalActive"
      :scope-id="rowData.id"
      :activity="activity"
      @close-modal="historicalModalClose"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  props: {
    activity: String,
    title: String,
  },
  data() {
    return {
      tableId: "scopes-evaluator-table",
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      rowData: {},
      showOriginal: false,
      show401: false,
      show505: false,
      show605: false,
      options: {
        url: `request/scopes_active?accAppId=${this.$store.state.accreditation.id}`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "scopes-evaluator-modal",
            modalId: "add-edit-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "scopes-evaluator-delete-modal",
            modalId: "delete",
          },
          {
            title: "Histórico",
            icon: "book",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      optionsOriginal: {
        url: `request/scopes_original?accAppId=${this.$store.state.accreditation.id}`,
        name: "",
        showHeader: true,
        columns: [],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: false,
        orderBy: "desc",
        actionType: "default",
      },
      // options401: {
      //   url: `request/scopes_historical?accAppId=${this.$store.state.accreditation.id}&statusId=25`,
      //   name: "",
      //   showHeader: true,
      //   columns: [],
      //   showFilter: false,
      //   showSearch: false,
      //   paginationType: "pagination",
      //   responsive: true,
      //   rowLimit: 10,
      //   showAction: false,
      //   orderBy: "desc",
      //   actionType: "default",
      // },
      // options505: {
      //   url: `request/scopes_historical?accAppId=${this.$store.state.accreditation.id}&statusId=35`,
      //   name: "",
      //   showHeader: true,
      //   columns: [],
      //   showFilter: false,
      //   showSearch: false,
      //   paginationType: "pagination",
      //   responsive: true,
      //   rowLimit: 10,
      //   showAction: false,
      //   orderBy: "desc",
      //   actionType: "default",
      // },
      // options605: {
      //   url: `request/scopes_historical?accAppId=${this.$store.state.accreditation.id}&statusId=43`,
      //   name: "",
      //   showHeader: true,
      //   columns: [],
      //   showFilter: false,
      //   showSearch: false,
      //   paginationType: "pagination",
      //   responsive: true,
      //   rowLimit: 10,
      //   showAction: false,
      //   orderBy: "desc",
      //   actionType: "default",
      // },
      historicalModalActive: false,
      scopeId: null,
    };
  },
  computed: {
    showCondition() {
      let res = false;
      if (this.$store.state.accreditation.currentStatus == 620 || this.$store.state.accreditation.currentStatus == 621) {
        res = true;
      }
      return res;
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": async function(value) {
      if (value) {
        this.getData();
      }
    },
  },
  created() {
    let columns = [];
    if (["OCPR"].includes(this.activity)) columns = this.OCPR;
    else if (["CSGAS"].includes(this.activity)) columns = this.CSGAS;
    else if (["OCSG", "CSA"].includes(this.activity)) columns = this.OCSG;
    else if (["CSST"].includes(this.activity)) columns = this.CSST;
    else if (["CSEN"].includes(this.activity)) columns = this.CSEN;
    else if (["CSIA"].includes(this.activity)) columns = this.CSIA;
    else if (["OCPE"].includes(this.activity)) columns = this.OCPE;
    else if (["OINSP"].includes(this.activity)) columns = this.OINSP;
    else if (["OENY"].includes(this.activity)) columns = this.OENY;
    else if (["OICC"].includes(this.activity)) columns = this.OICC;
    else if (["OCLN"].includes(this.activity)) columns = this.OCLN;
    else if (["OEYC"].includes(this.activity)) columns = this.OEYC;
    else if (["OEAP"].includes(this.activity)) columns = this.OEAP;
    else if (["OVV"].includes(this.activity)) columns = this.OVV;
    else if (["CSDM"].includes(this.activity)) columns = this.CSDM;
    this.options.columns = [...columns, this.actionObj];
    console.log(this.activity);
    this.optionsOriginal.columns = [...columns];
    // this.options401.columns = [...columns];
    // this.options505.columns = [...columns];
    // this.options605.columns = [...columns];

    if (this.$store.state.accreditation.app.status == 43) {
      this.getData();
    }
  },
  methods: {
    async getData() {
      try {
        const accAppId = this.$store.state.accreditation.app.id;
        let statusId = this.$store.state.accreditation.app.status;
        if (statusId != 43)
          statusId = this.$store.state.evaluatorReview.evalTest.status;

        const result = await this.axiosGet(
          `request/scopes_historical?accAppId=${accAppId}&statusId=`
        );
        const historical = result.data.data;
        const original = historical.filter((row) => row.status_id == null);

        // // 401
        // const _401 = historical.filter((row) => row.status_id == 25);
        // this.show401 = _401.length > 0 && [35, 43].includes(statusId);

        // // 505
        // const _505 = historical.filter((row) => row.status_id == 35);
        // this.show505 = _505.length > 0 && [35, 43].includes(statusId);

        // // 605
        // const _605 = historical.filter((row) => row.status_id == 43);
        // this.show605 = _605.length > 0 && statusId == 43;

        // this.showOriginal = _401.length > 0 || this.show505 || this.show605;
        if (this.$store.state.accreditation.currentStatus == 620 || this.$store.state.accreditation.currentStatus == 621) {
          this.showOriginal = false;
        } else {
          this.showOriginal = historical.length > original.length;
        }
      } catch (error) {
        console.log(error);
      }
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `request/${rowData.id}`;
        this.openAddEditModal();
      } else if (actionObj.title == this.$t("Histórico")) {
        this.historicalModalActive = true;
      }
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `request/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.getData();
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    historicalModalClose() {
      this.historicalModalActive = false;
    },

    reSetData() {
      this.getData();
      this.rowData = {};
      this.selectedUrl = "";
    },

    openTab(type, tableName) {
      const accAppId = this.$store.state.accreditation.app.id;
      let statusId = this.$store.state.accreditation.app.status;
      if (statusId != 43)
        statusId = this.$store.state.evaluatorReview.evalTest.status;

      let url = `/common/scopes/export?
        type=${type}
        &accAppId=${accAppId}
        &statusId=${statusId}
        &tableName=${tableName}`;
      window.open(url, "_blank").focus();
    },
  },
};
</script>
